import { Injectable } from '@angular/core';
import { RmtPopupComponent } from 'components/rmt-popup/rmt-popup';
import { ICancelReasons, ICancelReasonsSeg } from '../../model/api/cancel-reasons/cancel-reasons.interface';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { TranslateService } from "@ngx-translate/core";
import { APP_CONFIG } from '../../environment';
import { HttpProvider } from '../http/http';
import { ReasonsTypeId } from '../../model/types/primary-cancellation-reasons-icons-types';
import { CancelReasonKeys, CancelReasonType } from '../../model/types/cancel-reason-type';

@Injectable()
export class CancellationReasonProvider {

  cancellationReasons: ICancelReasons[] = [];
  cancelReasonType: string = '';

  constructor(
    private httpProvider: HttpProvider,
    private translate: TranslateService,
  ) {
  }

  async getCancelReasons(orderNumber: string): Promise<ICancelReasons[]> {
    this.cancelReasonType = '';
    const resp = await this.httpProvider.get(`${APP_CONFIG.remittanceApiBaseUrl}Order/${orderNumber}/CancelReasons`);
    this.cancellationReasons = resp;
    return resp;

  }

  getDeleteCancelReasons(): ICancelReasons[] {
    this.cancelReasonType = CancelReasonType.DELETE;
    const deleteCancelReasonsKeys = [
      CancelReasonKeys.CancelReasoonFeedbackName,
      CancelReasonKeys.CancelReasoonFeedbackDetails,
      CancelReasonKeys.CancelReasoonFeedbackError,
      CancelReasonKeys.CancelReasoonFeedbackInactive,
      CancelReasonKeys.CancelReasoonChangeCountry,
    ];
    
    var deleteReasons: ICancelReasons[] = [];

    // randomize the keys
    const shuffledKeys = deleteCancelReasonsKeys.sort(() => Math.random() - 0.5);

    shuffledKeys.forEach((value, index) => {
      const cancelObject = {} as ICancelReasons;
      cancelObject.id = index;
      cancelObject.key = value;
      cancelObject.name = this.translate.instant(value);
      cancelObject.pageNumber = 1;
      deleteReasons.push(cancelObject);
    });

    return deleteReasons;
  }

  /* TODO: remove the images for order cancellation reasons in future if needed */
  /* keeping them at this moment even after hiding the images as per the AC of https://euronet.atlassian.net/browse/OM-16488
  since the images are closely coupled with the reasons data structure and will affect deletion reasons as well */
  getIconForPrimaryReasonWith(id: number) {
    switch (id) {
      case ReasonsTypeId.RateIncreased:
        return 'transfer_details_exchange_rate_icon';
      case ReasonsTypeId.RecipientDetailsIncorrect:
        return 'transfer_details_user_icon';
      case ReasonsTypeId.ChangePickupLocation:
        return 'transfer_details_merchant_icon';
      case ReasonsTypeId.RequirePaymentMethodChange:
        return 'transfer_details_payment_method_icon';
      case ReasonsTypeId.IncorrectAmount:
        return 'transfer_details_currency_icon';
      default:
        return '';
    }
  }

  getIconForDeletionReasonWith(idx: number) {
    switch (idx) {
      case 0:
        return 'user_name_incorrect_icon';
      case 1:
        return 'user_details_incorrect_icon';
      case 2:
        return 'user_transfer_error_icon';
      case 3:
        return 'user_account_inactive_icon';
      case 4:
        return 'user_account_urgent_icon';
      default:
        return 'user_account_urgent_icon';
    }
  }


  segregateCancelReasonsByPage(reasons: ICancelReasons[]): ICancelReasonsSeg {

    const reasonMap = reasons.map(((reason, idx) => {
      const imageName = this.cancelReasonType === CancelReasonType.DELETE ?
            this.getIconForDeletionReasonWith(idx) :
            this.getIconForPrimaryReasonWith(reason.id);
      const imagePath = imageName ? `../assets/icons/${imageName}.svg` : '';
      return { ...reason, image: imagePath };
    }))

    const firstPageReasons = reasonMap.filter(reason => {
      return reason.pageNumber === 1;
    });

    const secondPageReasons = reasonMap.filter(reason => {
      return reason.pageNumber === 2;
    });

    return { firstPageReasons, secondPageReasons };
  }
}



// WEBPACK FOOTER //
// ./src/providers/cancellation-reasons/cancellation-reason.ts